import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-gps",
  templateUrl: "./med-icon-gps.component.html",
})
export class MedIconGpsComponent extends SvgMixinComponent {}
